import React from 'react';
import c from '../w.js';

const IconDeleteOutlined = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 3H9H15H16V4V6H17H18H20V8H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V8H4V6H6H7H8V4V3ZM10 6H14V5H10V6ZM8 8V18C8 18.5523 8.44772 19 9 19H15C15.5523 19 16 18.5523 16 18V8H15H9H8Z"
      }
    )
  )
);

export { IconDeleteOutlined };
